import { PhaseDto } from "../../dtos/PhaseDto";
import { StepDto } from "../../dtos/StepDto";

export type DisplayType = "textbox" | "div" | "button";

export type PhaseInfoItem = { getData: () => Promise<PhaseDto | null> };

export type TemplatePhase = PhaseDto & { steps: StepDto[] };

export function isTemplatePhase(p: PhaseDto | null | undefined): p is TemplatePhase {
    return !!p && Array.isArray((p as any).steps);
}

// A task with the extended header sits under a header row that already shows the name (and its
// summary click), so the tasklist doesn't repeat it. Other tasks have no such row, and neither does
// templates mode, so those keep the name in the tasklist itself.
export function phaseNameShownInPhaseHeader(
    phase: PhaseDto | null | undefined,
    inTemplates: boolean
): boolean {
    return phase?.defaultPhase?.settings?.extendedHeader === true && !inTemplates;
}

export type TasksFeatureFlags = {
    // structural
    readOnly: boolean;
    deepLinkEnabled: boolean;

    // editing controls
    allowEditName: boolean;
    allowEditDueDate: boolean;
    allowEditRequest: boolean;
    allowEditResponse: boolean;

    // visibility
    showRequestSection: boolean;
    showResponseSection: boolean;
    showFiles: boolean;
    showComments: boolean;
    showStatusButtons: boolean;
    showDeleteButton: boolean;
    showPhaseSummaryButtons: boolean;

    // list interactions
    allowReorderSteps: boolean;
    allowAddSteps: boolean;

    // layout
    hideDetailView?: boolean; // Hide the right side detail/summary view (for templates with tab editor)
};

export const GRANT_DEFAULTS: TasksFeatureFlags = {
    readOnly: false,
    deepLinkEnabled: true,

    allowEditName: true,
    allowEditDueDate: true,
    allowEditRequest: true,
    allowEditResponse: true,

    showRequestSection: true,
    showResponseSection: true,
    showFiles: true,
    showComments: true,
    showStatusButtons: true,
    showDeleteButton: true,
    showPhaseSummaryButtons: true,

    allowReorderSteps: true,
    allowAddSteps: true,
};

export const TEMPLATE_DEFAULTS: TasksFeatureFlags = {
    readOnly: true,
    deepLinkEnabled: false,

    allowEditName: true,
    allowEditDueDate: false,
    allowEditRequest: true,
    allowEditResponse: false,

    showRequestSection: true,
    showResponseSection: false,
    showFiles: true,
    showComments: false,
    showStatusButtons: false,
    showDeleteButton: false,
    showPhaseSummaryButtons: false,

    allowReorderSteps: false,
    allowAddSteps: false,
};

export const NONE_WORKFLOW_DEFAULTS: TasksFeatureFlags = {
    readOnly: false,
    deepLinkEnabled: true,

    allowEditName: true,
    allowEditDueDate: false,
    allowEditRequest: false,
    allowEditResponse: false,

    showRequestSection: false,
    showResponseSection: false,
    showFiles: true,
    showComments: false,
    showStatusButtons: false, // Will be replaced with Save/Complete buttons
    showDeleteButton: true,
    showPhaseSummaryButtons: false,

    allowReorderSteps: true,
    allowAddSteps: true,
};
